export default "__VITE_ASSET__BxIZ5n0F__"